import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import type { AccountInfo } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter } from 'react-router-dom';

import { msalConfig } from './authConfig';
import { App } from './App';
import './styles.css';

/**
 * Startet die Anwendung, sobald MSAL bereit ist.
 *
 * Die Initialisierung steht bewusst in einer Funktion und nicht auf oberster
 * Ebene: Ein Top-Level-await verlangt ein Ausgabeziel, das aeltere Browser
 * nicht unterstuetzen - der Build bricht sonst ab.
 */
async function starten() {
  const msal = new PublicClientApplication(msalConfig);

  // Muss vor jedem anderen Aufruf geschehen, sonst schlagen Anmeldeversuche
  // mit einer Meldung fehl, die den Grund nicht nennt.
  await msal.initialize();

  // Nach einem Neuladen ist zwar das Konto im Zwischenspeicher, aber nicht
  // als aktives gesetzt. Ohne das oeffnet acquireTokenSilent unnoetig ein
  // Fenster.
  const konten = msal.getAllAccounts();
  if (konten.length > 0) msal.setActiveAccount(konten[0]);

  msal.addEventCallback((ereignis) => {
    if (ereignis.eventType === EventType.LOGIN_SUCCESS && ereignis.payload) {
      const nutzlast = ereignis.payload as { account?: AccountInfo };
      if (nutzlast.account) msal.setActiveAccount(nutzlast.account);
    }
  });

  // Eine Anmeldung ueber Umleitung kehrt hierher zurueck; der Aufruf schliesst
  // sie ab.
  await msal.handleRedirectPromise();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msal}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>,
  );
}

starten().catch((fehler) => {
  // Scheitert der Start, bliebe die Seite sonst leer - ohne Hinweis, woran es
  // liegt. Die haeufigste Ursache sind fehlende Build-Werte.
  document.getElementById('root')!.innerHTML = `
    <div style="max-width:520px;margin:80px auto;font-family:sans-serif">
      <h1 style="font-size:20px;font-weight:300">Die Anwendung konnte nicht starten</h1>
      <pre style="background:#fafafa;border:1px solid #e2e2e2;border-radius:3px;
                  padding:14px;white-space:pre-wrap;font-size:13px">${
                    fehler instanceof Error ? fehler.message : String(fehler)
                  }</pre>
    </div>`;
});
